import { BaseConfig } from "@neru/base/utils";

import type { RouteWhitelist } from "./AdobeAnalytics";

export const trackedRoutes: RouteWhitelist = [
  { path: "/", track: "every" },
  { path: "/:productId", track: "every" },
  { path: "/:productId/documentation", track: "every" },
  { path: "/:productId/releases", track: "every" },
  { path: "/:productId/clients", track: "every" },
  { path: "/:productId/versions", track: "every" },
  { path: "/:productId/versions/:versionId", track: "every" },
  { path: "/workspaces", track: "every" },
  { path: "/workspaces/create", track: "every" },
  { path: "/workspaces/:workspaceId", track: "every" },
  { path: "/deployed-products", track: "every" },
  { path: "/deployed-products/:productId", track: "every" },
  { path: "/publish", track: "every" },
  { path: "/publish/:productId", track: "every" },
];

class Config extends BaseConfig {
  private routerBase = import.meta.env.VITE_ROUTER_BASENAME || "/";

  get routerBaseName() {
    return this.basePath
      ? `${this.basePath}${this.routerBase}`
      : this.routerBase;
  }

  get authConfig() {
    return {
      clientId: import.meta.env.VITE_AUTH_CLIENT_ID || "neru-cloud-runtime",
      provider: `${import.meta.env.VITE_AUTH_ISSUER}/oauth2`,
      redirectUri:
        // strip trailing slash from route
        window.location.origin + this.routerBaseName.replace(/\/$/, ""),
    };
  }

  get splitConfig() {
    return {
      core: {
        authorizationKey: import.meta.env.VITE_SPLIT_AUTHORIZATION_KEY ?? "",
        key: localStorage.getItem("vch.account_id") ?? "MARKET",
      },
    };
  }

  get skipAuth() {
    return Boolean(import.meta.env.VITE_BYPASS_AUTH);
  }
}

export const config = new Config();
